const ScoreToWin = {
  LowScore: 0,
  MaxPar: 1,
  MaxBirdie: 2,
};

export default ScoreToWin;
